import React from "react";

const DoctorInfoModal = ({ activeDoctorData, doctorImages }) => {
  const showDoctorItemData = (item, ind) => {
    if (item.type === "image") {
      return (
        <div key={ind} className="mb-3 mb-lg-4">
          <div className="doctor-modal-img-wrapper">
            <img src={doctorImages[item?.content]} alt={item?.dataHeader} />
          </div>
        </div>
      );
    } else if (item.type === "heading") {
      return (
        <div key={ind} className="mb-3 mb-lg-4 text-center">
          <h4 key={ind} className="doctor-info-modal-head">
            {item?.content}
          </h4>
        </div>
      );
    } else if (item.type === "para") {
      return (
        <div key={ind} className="mb-3">
          <div className="doctor-info-modal-sub-head">{item?.dataHeader}</div>
          {item?.content.length > 0 &&
            item?.content.map((val, i) => (
              <p className="doctor-info-modal-para" key={i}>
                {val}
              </p>
            ))}
        </div>
      );
    } else if (item.type === "link") {
      return (
        <div key={ind} className="mb-3 doctor-info-modal-content-wrapper">
          <div className="doctor-info-modal-sub-head">{item?.dataHeader}</div>
          <div className="doctor-info-modal-links">
            {item?.content.map((val, i) => (
              <a
                key={i}
                href={val.body}
                target="_blank"
                rel="noopener noreferrer"
              >
                {val.head}
              </a>
            ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="modal fade doctor-info-modal"
      id="doctorInfoModal"
      tabIndex="-1"
      aria-labelledby="doctorInfoModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" tabIndex="0">
            <div className="modal-heading">
              Special Thanks To Our Incredible Doctor
            </div>

            {Object.keys(activeDoctorData).length > 0 &&
              activeDoctorData?.data.length > 0 &&
              activeDoctorData?.data.map((item, i) =>
                showDoctorItemData(item, i)
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorInfoModal;
